module.exports = __webpack_public_path__ + "static/img/bca_logo.00d32516.png";